import config from 'config';
import pdfIcon from 'assets/icons/pdf.svg';
import linkIcon from 'assets/icons/link.svg';
import dcmIcon from 'assets/icons/dcm.png';
import filePlaceholder from 'assets/img/placeholder.png';

export enum FileTypesEnum {
  pdf = 'pdf',
  dcm = 'dcm',
  image = 'image',
  zip = 'zip'
}

export const getFileTypeName = (file?: string) => {
  if (!file) {
    return null;
  }

  const fileName = file.split('.');

  switch (fileName[fileName.length - 1]?.toLowerCase()) {
    case 'pdf':
      return FileTypesEnum.pdf;
    case 'dcm':
      return FileTypesEnum.dcm;
    case 'zip':
      return FileTypesEnum.zip;
    default:
      return FileTypesEnum.image;
  }
};

export const getFileIcon = (type?: FileTypesEnum | null) => {
  if (!type) {
    return '';
  }

  switch (type) {
    case FileTypesEnum.pdf:
      return pdfIcon;
    case FileTypesEnum.dcm:
      return dcmIcon;
    default:
      return linkIcon;
  }
};

export const getFileUrl = (
  file?: string | null,
  placeholder = filePlaceholder,
  size: number | null = 150
) => {
  if (!file) {
    return placeholder;
  }

  return `${config.base_url}/aws-s3/file/${file}${size ? `?size=${size}` : ''}`;
};

export const downloadFileFromUrl = (url: string, fileName: string) => {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.rel = 'noreferrer';
  a.download = fileName || 'download';

  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
};
